import {
    IS_FORMATION_LOADING,
    FORMATIONS_HAS_ERROR,
    FORMATIONS_FETCH_DATA_SUCCESS,
    FORMATIONS_VISIBILITY_UPDATE,
    IS_PLAYER_LOADING,
    PLAYERS_HAS_ERROR,
    PLAYERS_FETCH_DATA_SUCCESS,
    IS_BADGES_LOADING,
    BADGES_HAS_ERROR,
    BADGES_FETCH_DATA_SUCCESS,
    CREATE_TEAM,
    ADD_OR_REMOVE_PLAYER,
    UPDATE_MOBILE_PLAYER_LISTING_VISIBILITY,
    SET_HIGHLIGHT,
    RESET_ERROR,
    MAKE_CAPTAIN,
    REMOVE_CAPTAIN,
    REMOVE_PLAYER,
    SET_TUTORIAL_COOKIE,
    SET_MANAGE_TEAM_TUTORIAL_COOKIE,
    SET_SUBSTITUTION_TUTORIAL_COOKIE,
    RESET_TEAM,
    AUTO_FILL,
    RESET_API_ERROR,
    RESET_COMMON_ERROR,
    OPEN_MOBILE_FILTER,
    SET_BADGE,
    SET_TEAM_NAME,
    IS_TEAM_NAME_VALIDATION_LOADING,
    TEAM_NAME_VALIDATION_HAS_ERROR,
    TEAM_NAME_VALIDATION_FETCH_DATA_SUCCESS,
    IS_CLUBS_LOADING,
    CLUBS_FETCH_DATA_SUCCESS,
    CLUBS_HAS_ERROR,
    SET_CLUB_ID,
    IS_SAVE_TEAM_LOADING, SAVE_TEAM_FETCH_DATA_SUCCESS, SAVE_TEAM_HAS_ERROR,
    IS_PLAYER_CARD_LOADING,
    PLAYER_CARD_HAS_ERROR,
    PLAYER_CARD_FETCH_DATA_SUCCESS,
    TRIGGER_HANDLE_PLAYER_CARD,
    LIVE_SCORE_FETCH_DATA_SUCCESS,
    IS_LIVE_SCORE_LOADING,
    LIVE_SCORE_HAS_ERROR,
    SET_MANAGE_TEAM_MODE,
    IS_TRANSFER_TEAM_LOADING, TRANSFER_TEAM_HAS_ERROR, TRANSFER_TEAM_FETCH_DATA_SUCCESS,
    IS_LIMITLESS_TEAM_LOADING, LIMITLESS_TEAM_HAS_ERROR, LIMITLESS_TEAM_FETCH_DATA_SUCCESS,
    IS_SUBSTITUTION_TEAM_LOADING, SUBSTITUTION_TEAM_HAS_ERROR, SUBSTITUTION_TEAM_FETCH_DATA_SUCCESS,
    IS_CAPTAIN_LOADING, CAPTAIN_HAS_ERROR, CAPTAIN_FETCH_DATA_SUCCESS,
    SET_POPUP_STATE,
    SET_BOOSTER_POPUP_STATE,
    UPDATE_SAVE_BTN_STATUS,
    TRIGGER_HANDLE_FIXTURE_POPUP,
    UPDATE_BOOSTER_STATUS,
    MIX_FETCH_DATA_SUCCESS,
    SET_TEAM_LOCK_TOAST_COOKIE,
    IS_SHARE_TEAM_LOADING,
    TEAM_SHARE_SUCCESS,
    TEAM_SHARE_ERROR,
    TEAM_SHARE_CLEAR,
    APPLY_SKILL_FILTER,
    IS_PLAYER_RECOMENDATION_LOADING,
    SET_PLAYER_RECOMENDATION_FIRST_POPUP_FALSE,
    PLAYER_RECOMENDATION_SUCCESS,
    PLAYER_RECOMENDATION_ERROR,
    PLAYER_RECOMENDATION_POPUP_SHOW_HIDE,
    SET_PLAYER_RECOMENDATION_KEY,
    SHOW_PLAYER_RECOMD_MOB_POP_UP,
    SHOW_HIDE_PLAYER_RECOMD_TOGGLE_WEB,
    SHOW_HIDE_PLAYER_RECOM_POP_UP_MOB
} from './../constants/action-types';
import config from './../config';
import common from './../common';
import { getOrderedPlayerIDs } from './../helper';
import {
    formations,
    playerListing,
    badgesAPI,
    teamNameValidationAPI,
    clubLeagues,
    saveTeam,
    playerCardAPI,
    liveScoreAPI,
    mixedAPI,
    saveTransfersAPI,
    saveLimitlessAPI,
    saveSubstitutionsAPI,
    saveCaptainAPI,
    shareTeam,
    playerRecomendation
} from "../constants/api-url";
import {
    playerRecCategoryAPI
} from "../constants/api-url";

export function isFormationLoading(bool) {
    return {
        type: IS_FORMATION_LOADING,
        payload: bool
    };
}

export function hasError(bool) {
    return {
        type: FORMATIONS_HAS_ERROR,
        payload: bool
    };
}

export function fetchDataSuccess(formations) {
    return {
        type: FORMATIONS_FETCH_DATA_SUCCESS,
        payload: formations
    };
}

export function isClubsLoading(bool) {
    return {
        type: IS_CLUBS_LOADING,
        payload: bool
    };
}

export function clubsHasError(bool) {
    return {
        type: CLUBS_HAS_ERROR,
        payload: bool
    };
}

export function fetchClubSuccess(formations) {
    return {
        type: CLUBS_FETCH_DATA_SUCCESS,
        payload: formations
    };
}

export function isSaveTeamLoading(bool) {
    return {
        type: IS_SAVE_TEAM_LOADING,
        payload: bool
    };
}

export function saveTeamHasError(bool) {
    return {
        type: SAVE_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function saveTeamSuccess(response) {
    return {
        type: SAVE_TEAM_FETCH_DATA_SUCCESS,
        payload: response
    };
}

export function isPlayersLoading(bool) {
    return {
        type: IS_PLAYER_LOADING,
        payload: bool
    };
}

export function PlayersHasError(bool) {
    return {
        type: PLAYERS_HAS_ERROR,
        payload: bool
    };
}

export function PlayersFetchDataSuccess(players) {
    return {
        type: PLAYERS_FETCH_DATA_SUCCESS,
        payload: players
    };
}

export function isBadgesLoading(bool) {
    return {
        type: IS_BADGES_LOADING,
        payload: bool
    };
}

export function badgesHasError(bool) {
    return {
        type: BADGES_HAS_ERROR,
        payload: bool
    };
}

export function fetchBadgesSuccess(formations) {
    return {
        type: BADGES_FETCH_DATA_SUCCESS,
        payload: formations
    };
}

export function updatePopupVisibility() {
    return {
        type: FORMATIONS_VISIBILITY_UPDATE,
        payload: null
    };
}

export function createTeamForSelectedFormation(constraints, oldFormationId, newFormationId) {
    return {
        type: CREATE_TEAM,
        payload: { constraints, oldFormationId, newFormationId }
    };
}

export function addOrRemovePlayer(playerObj) {
    return {
        type: ADD_OR_REMOVE_PLAYER,
        payload: playerObj
    };
}

export function showHidePlayerRecomendationPopUpMob(bool) {
    return {
        type: SHOW_HIDE_PLAYER_RECOM_POP_UP_MOB,
        payload: bool
    };
}



export function removePlayer(playerObj) {
    return {
        type: REMOVE_PLAYER,
        payload: playerObj
    };
}

export function resetTeam(constraints, oldFormationId, newFormationId) {

    return {
        type: RESET_TEAM,
        payload: { constraints, oldFormationId, newFormationId }
    };
}

export function autoFillTeam() {
    let pageName = "";
    if (window.location.pathname.indexOf("/manage-team")) {
        pageName = "/uclfantasy/my-team/manage/"
    } else {
        pageName = "/uclfantasy/create-team/"
    }
    common.customTracking('Auto Complete', pageName);
    return {
        type: AUTO_FILL,
        payload: null
    };
}

export function openMobilePlayerListing(showHide) {
    return {
        type: UPDATE_MOBILE_PLAYER_LISTING_VISIBILITY,
        payload: showHide
    };
}

export function resetErrorMessages() {
    return {
        type: RESET_ERROR,
        payload: null
    };
}

export function resetGenericError() {
    return {
        type: RESET_COMMON_ERROR,
        payload: null
    };
}

export function openMobileFilter(bool) {
    return {
        type: OPEN_MOBILE_FILTER,
        payload: bool
    };
}

export function setHighlight(obj) {
    return {
        type: SET_HIGHLIGHT,
        payload: obj
    };
}

export function makeCaptain(obj) {
    return {
        type: MAKE_CAPTAIN,
        payload: obj
    };
}

export function removeCaptain(obj) {
    return {
        type: REMOVE_CAPTAIN,
        payload: obj
    };
}

export function setTutorialCookie() {
    return {
        type: SET_TUTORIAL_COOKIE,
        payload: null
    };
}

export function setManageTeamTutorialCookie() {
    return {
        type: SET_MANAGE_TEAM_TUTORIAL_COOKIE,
        payload: null
    };
}

export function setSubstitutionTutorialCookie() {
    return {
        type: SET_SUBSTITUTION_TUTORIAL_COOKIE,
        payload: null
    };
}

export function resetAPIPError() {
    return {
        type: RESET_API_ERROR,
        payload: null
    };
}

export function setBadge(badgeID) {
    return {
        type: SET_BADGE,
        payload: badgeID
    };
}

export function setTeamName(teamName) {
    return {
        type: SET_TEAM_NAME,
        payload: teamName
    };
}

export function setClubID(clubID) {
    return {
        type: SET_CLUB_ID,
        payload: clubID
    };
}

export function isTeamNameValidationLoading(bool) {
    return {
        type: IS_TEAM_NAME_VALIDATION_LOADING,
        payload: bool
    };
}

export function fetchTeamNameValidationSuccess(response) {
    return {
        type: TEAM_NAME_VALIDATION_FETCH_DATA_SUCCESS,
        payload: response
    };
}

export function teamNameValidationHasError(bool) {
    return {
        type: TEAM_NAME_VALIDATION_HAS_ERROR,
        payload: bool
    };
}

export function formationsFetchData(GamedayId) {
    let params = {
        gamedayId: GamedayId,
    };
    return (dispatch) => common.makeAPICall(formations, dispatch, isFormationLoading, fetchDataSuccess, hasError, params);
}

export function fetchClubs() {
    let params = {
        language: config.CURRENT_LANGUAGE,
    };
    return (dispatch) => common.makeAPICall(clubLeagues, dispatch, isClubsLoading, fetchClubSuccess, clubsHasError, params);
}

export function teamNameValidation(enteredTeamName) {
    const params = {
        optType: 1,
        teamName: enteredTeamName
    };
    return (dispatch) => common.makeAPICall(teamNameValidationAPI, dispatch, isTeamNameValidationLoading, fetchTeamNameValidationSuccess, teamNameValidationHasError, params, 'POST');
}

export function playersFetchData(GamedayId) {
    let params = {
        gamedayId: GamedayId,
        language: config.CURRENT_LANGUAGE,
    };
    return (dispatch) => common.makeAPICall(playerListing, dispatch, isPlayersLoading, PlayersFetchDataSuccess, PlayersHasError, params);
}

export function fetchPlayerRecomendation() {
    let params = {
        language: config.CURRENT_LANGUAGE,
    };
    return (dispatch) => common.makeAPICall(playerRecomendation, dispatch, isPlayerRecomendationLoading, PlayerRecomendationFetchSuccess, PlayerRecomendationHasError, params)
}

export function isPlayerRecomendationLoading(bool) {
    return {
        type: IS_PLAYER_RECOMENDATION_LOADING,

    };
}

export function setPlayerRecomendationFirstTimeFalse(bool) {
    return {
        type: SET_PLAYER_RECOMENDATION_FIRST_POPUP_FALSE,
        payload: bool
    };
}

export function setPlayerRecomendationKey(obj) {

    return (dispatch, getState) => {
        let playerRecomendedSelectedKey = obj.Key;
        let playerList = [];

        let store = getState();
        let params = {
            language: config.CURRENT_LANGUAGE,
            gamedayId: store.appData.constraints.GamedayId,
            category: playerRecomendedSelectedKey ? playerRecomendedSelectedKey.toLowerCase() : "category1"

        }
        let index = store.formationData.playerFilters.playerRecomendation.indexOf(playerRecomendedSelectedKey);
        if (index > -1) {
            dispatch({ type: 'SET_PLAYER_RECOMENDATION_KEY', payload: { Key: config.playerRecomendationDefault }, playerList: [] });
        } else {
            common.callBackApiCall(playerRecCategoryAPI, (recomendationPlayerList) => {
                playerList = recomendationPlayerList;

                dispatch({ type: 'SET_PLAYER_RECOMENDATION_KEY', payload: obj, playerList });

            }

                , (recomendationPlayerList) => {
                    playerList = recomendationPlayerList;
                    dispatch({ type: 'SET_PLAYER_RECOMENDATION_KEY', payload: obj, playerList });

                }, params)

        }

    }

}

export function PlayerRecomendationFetchSuccess(response) {
    return {
        type: PLAYER_RECOMENDATION_SUCCESS,
        payload: response
    };
}


export function showPlayerRecomMobPopUp(bool) {
    return {
        type: SHOW_PLAYER_RECOMD_MOB_POP_UP,
        payload: bool
    };
}

export function showHidePlayerRecomendationPopUp(bool) {
    return {
        type: PLAYER_RECOMENDATION_POPUP_SHOW_HIDE,
        payload: bool
    };
}

export function playerRecomendationToggleAction(bool) {
    return {
        type: SHOW_HIDE_PLAYER_RECOMD_TOGGLE_WEB,
        payload: bool
    };
}




export function PlayerRecomendationHasError(bool) {
    return {
        type: PLAYER_RECOMENDATION_ERROR,
        payload: bool
    };
}

export function badgesFetchData(GamedayId) {
    let params = {
        gamedayId: GamedayId,
    };
    return (dispatch) => common.makeAPICall(badgesAPI, dispatch, isBadgesLoading, fetchBadgesSuccess, badgesHasError, params);
}

export function toggleProgressAnimation() {
    return (dispatch) => {
        dispatch({ type: 'TOGGLE_PROGRESS_ANIMATION', payload: true });
        setTimeout(() => {
            dispatch({ type: 'TOGGLE_PROGRESS_ANIMATION', payload: false });
        }, 3000)
    };
}

export function postSaveTeam(guid, formationsID, constrains, teamData) {
    const data = {
        OptType: 1,
        Platform: config.PLATFORM_ID,
        GamedayId: constrains.GamedayId,
        PhaseId: constrains.PhaseId,
        CaptainId: teamData.captainID,
        IsWildcard: 0,
        InPlayerId: getOrderedPlayerIDs(teamData),
        InPlayerBenchPosition: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4],
        OutPlayerId: [0],
        OutPlayerBenchPosition: [0],
        SubPlayerId: [0],
        SubPlayerBenchPosition: [0],
        GDCompId: 9,
        MDCompId: formationsID,
        ISMCPR: 0,
        IsNewsletter: 0,
        LangCode: config.CURRENT_LANGUAGE,
        BadgeId: teamData.badgeID || 0,
        FavTeamId: teamData.clubID || 0,
        TeamName: teamData.teamName
    };
    let saveTeamAPI = saveTeam.replace('{GUID}', guid);
    return (dispatch) => common.makeAPICall(saveTeamAPI, dispatch, isSaveTeamLoading, saveTeamSuccess, saveTeamHasError, data, 'POST');
}

// transfers api
export function postTransferTeam(guid, obj) {
    const data = obj;
    let saveTransferAPI = saveTransfersAPI.replace('{GUID}', guid);
    return (dispatch) => common.makeAPICall(saveTransferAPI, dispatch, isTransferTeamLoading, transferTeamSuccess, transferTeamHasError, data, 'POST');
}

export function isTransferTeamLoading(bool) {
    return {
        type: IS_TRANSFER_TEAM_LOADING,
        payload: bool
    };
}

export function transferTeamHasError(bool) {
    return {
        type: TRANSFER_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function transferTeamSuccess(response) {
    return {
        type: TRANSFER_TEAM_FETCH_DATA_SUCCESS,
        payload: response
    };
}

// limitless api
export function postLimitlessTeam(guid, obj) {
    const data = obj;
    let saveLimitlessApi = saveLimitlessAPI.replace('{GUID}', guid);
    return (dispatch) => common.makeAPICall(saveLimitlessApi, dispatch, isLimitlessTeamLoading, limitlessTeamSuccess, limitlessTeamHasError, data, 'POST');
}

export function isLimitlessTeamLoading(bool) {
    return {
        type: IS_LIMITLESS_TEAM_LOADING,
        payload: bool
    };
}

export function limitlessTeamHasError(bool) {
    return {
        type: LIMITLESS_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function limitlessTeamSuccess(response) {
    return {
        type: LIMITLESS_TEAM_FETCH_DATA_SUCCESS,
        payload: response
    };
}

// substitution api
export function postSubstituteTeam(guid, obj) {
    const data = obj;
    let saveSubstitutionAPI = saveSubstitutionsAPI.replace('{GUID}', guid);
    return (dispatch) => common.makeAPICall(saveSubstitutionAPI, dispatch, isSubstitutionTeamLoading, substitutionTeamSuccess, substitutionTeamHasError, data, 'POST');
}

export function isSubstitutionTeamLoading(bool) {
    return {
        type: IS_SUBSTITUTION_TEAM_LOADING,
        payload: bool
    };
}

export function substitutionTeamHasError(bool) {
    return {
        type: SUBSTITUTION_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function substitutionTeamSuccess(response) {
    return {
        type: SUBSTITUTION_TEAM_FETCH_DATA_SUCCESS,
        payload: response
    };
}

export function postCaptain(guid, obj) {
    const data = obj;
    let saveCaptAPI = saveCaptainAPI.replace('{GUID}', guid);
    return (dispatch) => common.makeAPICall(saveCaptAPI, dispatch, isCaptainLoading, captainSuccess, captainHasError, data, 'POST');
}

export function isCaptainLoading(bool) {
    return {
        type: IS_CAPTAIN_LOADING,
        payload: bool
    };
}

export function captainHasError(bool) {
    return {
        type: CAPTAIN_HAS_ERROR,
        payload: bool
    };
}

export function captainSuccess(response) {
    return {
        type: CAPTAIN_FETCH_DATA_SUCCESS,
        payload: response
    };
}

export function playerCardFetchData(playerID) {
    let params = {
        playerId: playerID
    };
    return (dispatch) => common.makeAPICall(playerCardAPI, dispatch, isPlayerCardLoading, playerCardFetchDataSuccess, playerCardHasError, params);
}

export function isPlayerCardLoading(bool) {
    return {
        type: IS_PLAYER_CARD_LOADING,
        payload: bool
    };
}

export function playerCardFetchDataSuccess(playersCard) {
    return {
        type: PLAYER_CARD_FETCH_DATA_SUCCESS,
        payload: playersCard
    };
}

export function playerCardHasError(bool) {
    return {
        type: PLAYER_CARD_HAS_ERROR,
        payload: bool
    };
}

export function triggerHandlePlayerCard(isPlayerCardVisible, playerObj, playerInfoClicked, overview, gameday) {
    if (isPlayerCardVisible) {
        // common.virPathTracking('playerCard');
    }
    let overviewValue = "";
    if (overview == undefined) {
        overviewValue = false;
    } else {
        overviewValue = overview
    }

    return {
        type: TRIGGER_HANDLE_PLAYER_CARD,
        payload: { isPlayerCardVisible, playerObj, playerInfoClicked, overviewValue, gameday },
    }
}

export function triggerLiveScoreFetchData() {
    return (dispatch) => common.makeAPICall(liveScoreAPI, dispatch, isLiveScoreLoading, LiveScoreFetchDataSuccess, LiveScoreHasError);
}

export function isLiveScoreLoading(bool) {
    return {
        type: IS_LIVE_SCORE_LOADING,
        payload: bool
    };
}

export function LiveScoreFetchDataSuccess(liveData) {
    return {
        type: LIVE_SCORE_FETCH_DATA_SUCCESS,
        payload: liveData
    };
}

export function LiveScoreHasError(bool) {
    return {
        type: LIVE_SCORE_HAS_ERROR,
        payload: bool
    };
}

export function MixFetchDataSuccess(liveData) {
    return {
        type: MIX_FETCH_DATA_SUCCESS,
        payload: liveData
    };
}

export function triggerMixFetchData() {
    let mixedAPIURL = mixedAPI.replace('{TourId}', config.TourId)
    return (dispatch) => common.makeAPICall(mixedAPIURL, dispatch, isLiveScoreLoading, MixFetchDataSuccess, LiveScoreHasError);
}

export function setManageTeamMode(mode) {
    if (mode === config.modes['transfer']) {
        common.virPathTracking('Start Transfers - Pitch', '/uclfantasy/my-team/manage/');
    } else if (mode === config.modes['substitution']) {
        common.virPathTracking('substitutions');
    }

    return {
        type: SET_MANAGE_TEAM_MODE,
        payload: mode
    };
}

export function setPopupState(payload) {
    return {
        type: SET_POPUP_STATE,
        payload: payload
    };
}

export function setBoosterPopupState(payload) {
    return {
        type: SET_BOOSTER_POPUP_STATE,
        payload: payload
    };
}

export function updateSaveTeamBtnStatus(payload) {
    return {
        type: UPDATE_SAVE_BTN_STATUS,
        payload: payload
    };
}

export function triggerHandleFixturePopup(isFixturePopupVisible) {
    if (isFixturePopupVisible) {
        common.virPathTracking('fixturePopup');
    }
    return {
        type: TRIGGER_HANDLE_FIXTURE_POPUP,
        payload: { isFixturePopupVisible },
    }
}

export function updateBoosterStatus(key, value) {
    return {
        type: UPDATE_BOOSTER_STATUS,
        payload: { key, value },
    }
}

export function setTeamLockToastCookie(name) {
    return {
        type: SET_TEAM_LOCK_TOAST_COOKIE,
        payload: name
    };
}


export function isShareTeamLoading(bool) {

    return {
        type: IS_SHARE_TEAM_LOADING,
        payload: bool
    };
}

export function triggerShareTeamSuccess(name) {
    return {
        type: TEAM_SHARE_SUCCESS,
        payload: name
    };
}

export function triggerShareTeamError(name) {
    return {
        type: TEAM_SHARE_ERROR,
        payload: name
    };
}

export function triggerShareTeam(sharePayload) {
    let shareUrl = ""

    shareUrl = Object.keys(sharePayload)
        .map(k => encodeURIComponent(sharePayload[k]))
        .join('/');
    return (dispatch) => common.makeAPICall(shareTeam + shareUrl + '/generate', dispatch, isShareTeamLoading, triggerShareTeamSuccess, triggerShareTeamError);
}

export function triggerClearShareUrl() {
    return {
        type: TEAM_SHARE_CLEAR
    };
}

export function triggerPlayerSkillsFilter(skill) {
    return {
        type: APPLY_SKILL_FILTER,
        payload: skill
    };
}






// WEBPACK FOOTER //
// ./src/actions/FormationActions.js